import { useEffect } from "react";
import { useSelector } from "react-redux";

const TITLE_TOURIST = "TELEKOM Travellers' Sim";
const TITLE_DEFAULT = "(Prepaid) Mobile Internet";

/** Syncs `document.title` with tourist vs prepaid branding. */
export function useTouristDocumentTitle() {
	const isTourist = useSelector((state) =>
		Boolean(state?.BalanceReducer?.payloadAfterLogIn?.isTourist),
	);

	useEffect(() => {
		document.title = isTourist ? TITLE_TOURIST : TITLE_DEFAULT;
	}, [isTourist]);
}
